import { Component } from "react";
import UploadForm from "../UploadForm/UploadForm.component";
import UploadGroup from "../UploadGroup/UploadGroup.component";
import ActionGroup from "../ActionGroup/ActionGroup.component";
import { EnvPanelContainer, EnvPanelUploadGroup } from "./EnvPanel.styles";
import ActionForm from "../ActionForm/ActionForm.component";

class EnvPanel extends Component {

    render() {
        const BAIUrlTemplate = 'https://func-xmlfiletransformerclrv-env-ause.azurewebsites.net/api/BAIToXMLFunction';
        const BRFUrlTemplate = 'https://func-xmlfiletransformerclrv-env-ause.azurewebsites.net/api/BRFToXMLFunction';
        const TXTUrlTemplate = 'https://func-xmlfiletransformerclrv-env-ause.azurewebsites.net/api/DishonourFunction';
        const DOTUrlTemplate = 'https://func-xmlfiletransformerclrv-env-ause.azurewebsites.net/api/MultiMerchantFunction';
        const RPTUrlTemplate = 'https://func-xmlfiletransformerclrv-env-ause.azurewebsites.net/api/DisbursementFunction';
        const BatchUrlTemplate = 'https://func-batchorchestratorclrv-env-ause.azurewebsites.net/api/workflows-executions';
        const QueueUrlTemplate = 'https://sbus-glbclrv-env-ause.servicebus.windows.net';
        if (!this.props.envCode) {
            return (<EnvPanelContainer />);
        };

        var XMLENVStr = '-' + this.props.envCode.toLowerCase() + '-'
        if (this.props.envCode.toLowerCase() === 'dev') {
            XMLENVStr = '-all-';
        }
        const BAIUrl = BAIUrlTemplate.replace('-env-',XMLENVStr);
        const BRFUrl = BRFUrlTemplate.replace('-env-',XMLENVStr);
        const TXTUrl = TXTUrlTemplate.replace('-env-',XMLENVStr);
        const DOTUrl = DOTUrlTemplate.replace('-env-',XMLENVStr);
        const RPTUrl = RPTUrlTemplate.replace('-env-',XMLENVStr);
        const EODUrl = BatchUrlTemplate.replace('-env-', XMLENVStr);
        const BATUrl = BatchUrlTemplate.replace('-env-', XMLENVStr);
        const ODSUrl = BatchUrlTemplate.replace('-env-',XMLENVStr);
        const ALLUrl = BatchUrlTemplate.replace('-env-',XMLENVStr);
        const ADFUrl = BatchUrlTemplate.replace('-env-',XMLENVStr);

        if(process.env.REACT_APP_LOGGING_LEVEL !== '0') {
            console.log('rendering EnvPanel');
            console.log(JSON.stringify(this.props));
            console.log(BAIUrl);
            console.log(BRFUrl);
            console.log(TXTUrl);
            console.log(DOTUrl);
            console.log(RPTUrl);
        }

        const NABBankingUploads = [
            {code: 'BAI', name: 'Bank Statement', path: 'BAI', type: 'Upload', method: 'POST', url: BAIUrl, params: [], body: {}},
            {code: 'BRF', name: 'BPAY Reference File', path: 'BRF',type: 'Upload', method: 'POST', url: BRFUrl, params: [], body: {}},
            {code: 'RPT', name: 'Direct Debit Disbursement File', path: 'Disbursement',type: 'Upload', method: 'POST', url: RPTUrl, params: [], body: {}},
            {code: 'DOT', name: 'Multi Merchant File', path: 'MultiMerchant',type: 'Upload', method: 'POST', url: DOTUrl, params: [], body: {}},
            {code: 'TXT', name: 'Direct Debit Dishonours', path: 'Dishonour',type: 'Upload', method: 'POST', url: TXTUrl, params: [], body: {}},
        ]                

        const QueueProcessing = [
            {code: 'USM', name: 'Unclaimed Super Money', path: 'ssintg-incomingtopush', type: 'SOAPAPI', method: 'POST', url: BAIUrl, params: [], body: {}},
            {code: 'RTR', name: 'Rollover Transaction Request', path: 'ssintg-incomingtopush', type: 'SOAPAPI', method: 'POST', url: BAIUrl, params: [], body: {}}
        ]

        const BatchProcessing = [


            {code: 'DAY', name: 'Advance System Date', path: 'DAY',type: 'Action', method: 'POST', url: EODUrl, params: [], body: {
                tenant: 'Clearview',
                firstAction: 'sscycle-eod',
                name: 'selfservice'       
            }},
            {code: 'BAT', name: 'Daily Batch Process', path: 'BAT',type: 'Action', method: 'POST', url: BATUrl, params: [], body: {
                tenant: 'Clearview',
                firstAction: 'dailyfunc-stop',
                name: 'daily'       
            }},
            {code: 'ODS', name: 'ODS Refresh Process', path: 'ODS',type: 'Action', method: 'POST', url: ODSUrl, params: [], body: {
                tenant: 'Clearview',
                firstAction: 'dailyods-start',
                name: 'daily'       
            }},
            {code: 'EOD', name: 'Daily Cycle Process', path: 'EOD',type: 'Action', method: 'POST', url: ADFUrl, params: [], body: {
                tenant: 'Clearview',
                firstAction: 'sscycle-001',
                name: 'selfservice'                
            }},
            {code: 'ON', name: 'Start SSIS Runtime', path: 'ON',type: 'Action', method: 'POST', url: ALLUrl, params: [], body: {
                tenant: 'Clearview',
                firstAction: 'ssisir-start',
                name: 'selfservice'                
            }},
            {code: 'OFF', name: 'Stop SSIS Runtime', path: 'OFF',type: 'Action', method: 'POST', url: ALLUrl, params: [], body: {
                tenant: 'Clearview',
                firstAction: 'ssisir-stop',
                name: 'selfservice'                
            }},
        ]                    

        /*    
        const SuperStreamEvents = [
            {code: 'RTR', name: 'Rollover Transaction Request', path: '',  url: 'https://'},
            {code: 'CTR', name: 'Contribution Transaction Request', path: '',  url: 'https://'},
            {code: 'IRR', name: 'Initiate Rollover Request', path: '',  url: 'https://'},
            {code: 'MRROR', name: 'Member Rollover Request Outcome Response', path: '',  url: 'https://'},
            {code: 'USMOR', name: 'Unclaimed Super Money Outcome Response', path: '',  url: 'https://'},
        ]                    
        */
        return (
            <EnvPanelContainer >
                <p>Manage {this.props.envCode} Environment</p>
                <EnvPanelUploadGroup>
                    <UploadGroup buttonList={NABBankingUploads} groupTitle='NAB Banking Uploads' groupCode='NAB' envCode={this.props.envCode}/>
                    <ActionGroup buttonList={BatchProcessing} groupTitle='Batch Processing' groupCode='BAT' envCode={this.props.envCode}/>

                    {
                        /*
                    <UploadGroup buttonList={SuperStreamEvents} groupTitle = 'SuperStream Messaging' groupCode='SuperStream' envCode={this.props.envCode}/>
                    */
                    }
                </EnvPanelUploadGroup>
                <UploadForm envCode={this.props.envCode}></UploadForm>
                <ActionForm envCode={this.props.envCode}></ActionForm>
            </EnvPanelContainer>
        );

    }
}
export default EnvPanel;